const AjaxFunctions = require('./ajaxFunctions.js');

const colorText1 =
   'Remember, to ensure your evidence is a complete sentence with a <span class="evidence-creation-subject">' +
   'subject </span> and <span class="evidence-creation-action">action</span>.';
const colorText2 =
   'Also good evidence often provides<span class="evidence-creation-results">' +
   'specific results </span> and <span class="evidence-creation-timeframe">a time frame</span>';
const colorText3 =
   '<span class="evidence-creation-subject">438,000 people</span> <span class="evidence-creation-action">died</span> ' +
   '<span class="evidence-creation-results">from malaria</span> <span class="evidence-creation-timeframe">in 2015.</span>';

exports.CreateEvidenceTour = (onEndCallback) => {
   return {
      id: "evidence-card-creation-walkthrough",
      steps: [
         {
            title: "Evidence Creation",
            content: "An Evidence Block is any piece of useful information drawn from a reputable source. ",
            target: document.querySelector("#cardCreationEvidenceRadio"),
            placement: "bottom"
         },
         {
            content: "With this in mind, when creating an Evidence Block, you'll start by citing it here.<br />" +
                     "(e.g. WHO World Malaria Report 2015, accessed 2/13/2018 )",
            target: document.querySelector("#cardCreationEvidenceCitation"),
            placement: "right",
         },
         {
            content: "If you have a <a href='https://www.doi.org/faq.html'>DOI</a> for your citation, you can enter it here.\n",
            target: document.querySelector("#cardCreationEvidenceSource"),
            placement: "right",
            onNext: () => {
               document.getElementById('cardCreationEvidenceSynopsis').scrollIntoView();
            }
         },
         {
            content: "Next, you'll enter the fact itself here. Remember that " + colorText1 + '<br />' + colorText2 +
                     "<br />(" + colorText3 + ")",
            target: document.querySelector("#cardCreationEvidenceSynopsis"),
            placement: "right",
            onNext: () => {
               document.getElementById('topic-search-text-input').scrollIntoView();
            }
         },
         {
            content: "You'll need to enter at least one topic for your evidence from the pre-defined options." +
            "Once you begin typing, your options will show up to the right",
            target: document.querySelector("#topic-search-text-input"),
            placement: "right",
            onNext: () => {
               document.getElementById('cardCreationEvidenceTags').scrollIntoView();
            }
         },
         {
            content: "Finally, you can optionally enter tags so that other users can search for it easier.",
            target: document.querySelector("#cardCreationEvidenceTags"),
            placement: "right",
            onNext: () => {
               document.getElementById('cardCreationEvidenceRadio').scrollIntoView();
            }
         },
         {
            content: "Ready to begin adding evidence to Polyplexus?  You can view ‘First Time User Instructions’ again if needed. " +
                     "Do not pull statements word for word from copyrighted material.<br />" +
                     "When you’re done composing, click Submit.  Your evidence will appear at the top of the list in the middle of the screen. <br />" +
                     "You can view the details of any card by clicking on a card in the List View from before.",
            target: document.querySelector("#cardCreationEvidenceRadio"),
            placement: "right",
         }
      ],
      onEnd: () => {
         AjaxFunctions.completeEvidenceTutorial().then(() => {
            onEndCallback();
         })
      },
      onClose: () => {
         AjaxFunctions.completeEvidenceTutorial().then(() => {
            onEndCallback();
         })
      }
   }
};

exports.CreateIntroTour = (onEndCallback, onCloseCallback) => {
   return {
      id: 'introTour1',
      i18n: {
         doneBtn: 'Done',
      },
      steps: [
         {
            content: "You have a new message!  Click here.",
            target: document.getElementById('messagesBadge'),
            placement: "left",
         },
      ],
      onEnd: () => {
         onEndCallback();
      },
      onClose: () => {
         onCloseCallback();
      }
   }
};

exports.CreateListViewTour = (onEndCallback, onCloseCallback) => {
   return {
      id: 'listViewTour',
      i18n: {
         doneBtn: 'Next'
      },
      steps: [
         {
            title: "List View",
            content: "These are the Evidence Statements the community is creating. The most recent entries appear at the top. " +
            "(Other methods for sorting and viewing will be added in future releases.)",
            target: document.querySelector("#displayPageContainer"),
            placement: "left",
         },
         {
            title: "Block Creation",
            content: "Compose your Evidence Statements here. Polyplexus has a point of view on good evidence construction " +
            "and our tutorial shows examples and the steps required for effective Evidence Statements. ",
            target: document.querySelector("#LeftBarHomeCreateNewCard"),
            placement: "right",
         },
      ],
      onEnd: () => {
         onEndCallback();
      },
      onClose: () => {
         onCloseCallback();
      }
   }
};


exports.CreateEvidenceDetailsTour = (onEndCallback, onCloseCallback) => {
   return {
      id: 'evidenceDetailsTour',
      i18n: {
         doneBtn: 'Next'
      },
      steps: [
         {
            title: "Evidence details",
            content: "Finished Evidence Statements include topic keywords. You can also click on the Creator’s name to get to their Profile Page.",
            target: document.querySelector("#displayPageContainer"),
            placement: "left",
         },
         {
            title: "Evidence details",
            content: "Topic filters allow you to sort the List View.",
            target: document.querySelector("#searchPanelSelectFilters"),
            placement: "right",
         },
      ],
      onEnd: () => {
         onEndCallback();
      },
      onClose: () => {
         onCloseCallback();
      }
   }
};

exports.CreateTopicListTour = (onEndCallback, onCloseCallback) => {
   return {
      id: 'topicFilterAndEndTour',
      i18n: {
         doneBtn: 'Next'
      },
      steps: [
         {
            title: "Topic Filter",
            content: "These are the topics currently offered. Click a filter and the list in the middle of the screen will only include those pieces of evidence. ",
            target: document.querySelector(".filter-category-header"),
            placement: "right",
         },
         {
            title: "Site Navigation",
            content: "Tap here to unfold additional navigation. You can explore these at your leisure, but note these sections of Polyplexus are still under development. ",
            target: document.querySelector("#topMenuIcon"),
            placement: "right",
         },
         {
            title: "Site Navigation",
            content: "This tab slides the left panel in and out. It will be useful in other views, but you will want to leave the left panel visible during evidence creation. ",
            target: document.querySelector(".hide-btn"),
            placement: "right",
         },
         {
            title: "Closing",
            content: "In the next Polyplexus release we will expand core mechanics, including linking various pieces of evidence together with reasoning and " +
            "enabling peer review of Evidence Statements. <br />" +
            "Thank you for helping us build a robust library of evidence and a community of rigorous and creative thinkers.",
            target: document.querySelector(".navbar-brand"),
            placement: "right",
         },
      ],
      onEnd: () => {
         onEndCallback();
      },
      onClose: () => {
         onCloseCallback();
      }
   }
};

